import ScrollSpy from 'react-scrollspy-navigation';
import './Nav.scss';
// import * as React from 'react';

// interface NavLinkProp {
//     id : string;
//     children: React.ReactNode;
// }

// function NavLink({id, children} : NavLinkProp) {
//     return (
//         <li> 
//             <a href={"#"+id}>{children}</a>
//         </li>
//     );
// }

 
export default function Nav() {  
  return (
    <ScrollSpy activeClass="active" offsetTop={50}>
    <nav><ul>  
      <li><a href="#sec-about">À propos</a></li> 
      <li><a href="#sec-projects">Projets</a></li>
      <li><a href="#contact">Contact</a></li>  
    </ul></nav>
    </ScrollSpy>
  );
} 

